import { getInitials } from 'helpers/textHelpers';
import {
  DEFAULT_OPERATION_DURATION_HOURS,
  DEFAULT_OPERATION_DURATION_MINUTES
} from 'screens/Applications&WorkOrders/StepsLayout/Constants/defaultDuration';
import {
  FormValues,
  RecordSourceType
} from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';
import generateDefaultApplicationId from 'screens/Applications&WorkOrders/StepsLayout/Helpers/generateDefaultApplicationId';

/**
 * Converts WorkOrder data to Formik-compatible Application form data
 */

const convertWorkOrderToApplicationFormikData = (
  workOrder: FormValues,
  previousValues?: FormValues,
  user?: { name: string }
): FormValues => {
  const endDateTime = workOrder.startDateTime
    .clone()
    .add(DEFAULT_OPERATION_DURATION_HOURS, 'hours');
  const durationHours = DEFAULT_OPERATION_DURATION_HOURS;
  const durationMinutes = DEFAULT_OPERATION_DURATION_MINUTES;

  const initials =
    user?.name && user.name.trim().length > 0 ? getInitials(user.name) : 'NA';

  return {
    ...previousValues,
    ...workOrder,
    id: undefined, // Clear id for new application
    applicationId: generateDefaultApplicationId(initials), // Clear applicationId for new application
    endDateTime,
    durationHours,
    durationMinutes,
    ...(workOrder.id && {
      recordSource: {
        recordSourceType: RecordSourceType.WORK_ORDER,
        recordSourceId: workOrder.id,
        recordSourceName: workOrder.applicationId
      }
    })
  };
};

export default convertWorkOrderToApplicationFormikData;
